import React from 'react';
import cx from 'classnames';

import BreadcrumbsItem, { BreadcrumbsItemProps } from './BreadcrumbsItem';
import Text from '../Text';

import styles from './Breadcrumbs.module.scss';

export interface BreadcrumbsComposite {
  Item: React.FC<BreadcrumbsItemProps>;
}
export interface Props {
  /** The content should be one or more `Breadcrumbs.Item`. */
  children?:
    | React.ReactElement<BreadcrumbsItemProps>
    | React.ReactElement<BreadcrumbsItemProps>[];
  /** Apply CSS class to `Breadcrumbs`. */
  className?: Parameters<typeof cx>[0];
  /** Accessible name for `Breadcrumbs`, which will be visually hidden by default. */
  label: string;
}

export const Breadcrumbs: React.FC<Props> & BreadcrumbsComposite = ({
  children,
  className,
  label,
}) => {
  const arrayChildren = React.Children.toArray(children);

  return (
    <nav aria-label={label}>
      <ul className={cx(styles.breadcrumbs, className)}>
        {React.Children.map(children, (child, index) => {
          const isLast = index === arrayChildren.length - 1;
          return (
            <>
              {child}
              {!isLast && (
                <Text as='span' className={styles.slash} aria-hidden='true'>
                  /
                </Text>
              )}
            </>
          );
        })}
      </ul>
    </nav>
  );
};

Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.Item = BreadcrumbsItem;

export default Breadcrumbs;
export { styles };
